"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var animation = {
  loading: "\n    from { background-position-x: 0; }\n    to { background-position-x: -20px; }\n  ",
  pulse: function pulse(originalSize, expandSize) {
    return "\n    from {\n      opacity: 0.8;\n      transform: scale(".concat(originalSize || 1, ");\n    }\n    to {\n      opacity: 0;\n      transform: scale(").concat(expandSize || 1.6, ");\n    }\n  ");
  }
};
var _default = exports.default = animation;